export default "__VITE_ASSET__sVOZAdvs__"